(function HotelSearchResults($, Adzuki)
{
	"use strict";


	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelBooking/searchResults', function onload()
		{
			var $results_map           = $(".hotel-results-map"),
			    $modal                 = $(".modal"),
			    total_items            = 0,
				$comparison_container  = $('.hotel-comparison-widget'),
			    results_map;

			if ($results_map.length)
			{
				results_map = new Adzuki.Map('.hotel-results-map');
				results_map.populate($results_map.data('results'));

				$("a.goto-marker").click(function gotoMarker(e) {
					e.preventDefault();
					results_map.selectMarker($(this).data('marker-id'));
				});
			}

			$(".btn-group.style-toggle label").click(function changeStyle()
			{
				var $self = $(this);

				if (!$self.hasClass('active')) {
					window.location.href = Adzuki.base_uri + '/HotelBooking/searchResults/'+$self.data('style');
				}
			});

			$(document).on('click', '.label.amenity', function showAmenity()
			{
				$modal.find('.modal-title').text('Amenity Information');
				$modal.find('.modal-body').html($(this).data('amenity'));
				$modal.modal('show');
			});

			$("a.show-more").click(function showMore(e)
			{
				var $self      = $(this),
				    $more_info = $self.parents('p').siblings('.more-info');

				e.preventDefault();

				if ($self.hasClass('active')) {
					$more_info.slideUp();
					$self.removeClass('disabled');
					$self.find('i').removeClass(Adzuki.FaIcon.getIconStyleName('chevron_up')).addClass(Adzuki.FaIcon.getIconStyleName('chevron_down'));
					$self.find('span').text($self.data('show-more'));
				}
				else if ($more_info.html().length) {
					$more_info.slideDown();
					$self.find('i').removeClass(Adzuki.FaIcon.getIconStyleName('chevron_down')).addClass(Adzuki.FaIcon.getIconStyleName('chevron_up'));
					$self.find('span').text($self.data('show-less'));
				}
				else {
					$self.addClass('disabled');
					$self.find('i').removeClass(Adzuki.FaIcon.getIconStyleName('chevron_down')).addClass(Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin');

					Adzuki.Ajax.get('/HotelBooking/getHotelDetails/'+$self.data('hotel-code'))
					.then(function _show(details)
					{
						$self.removeClass('disabled');
						$self.find('i').removeClass(Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin').addClass(Adzuki.FaIcon.getIconStyleName('chevron_up'));
						$self.find('span').text($self.data('show-less'));
						$more_info.html(details).slideDown();
					});
				}
			});

			// comparison stuff
			$('.hotel-comparison').click(function hotelComparisonClick(e) {
				var comparison_ids  = Cookies.get('hotel_comparison_ids') || '',
					comparison_str  = '',
					hotel_code      = $(this).data('hotel-code'),
					ids             = '',
					max_hotels      = 6, //	arbitrary
					i               = 0,
					min_total_items = 0;

				if ($(this).prop('checked') === true) {
					if (comparison_ids === '') {
						comparison_str = hotel_code;
						total_items    = 1;
					} else {
						ids         = comparison_ids.split(',');
						total_items = ids.length;

						if (ids.length >= max_hotels) {
							Adzuki.StatusMessage(null, 'You can only compare up to ' + max_hotels + ' hotels at a time', 'Max reached');

							comparison_str = comparison_ids;
							$(this).prop('checked', false);
						} else {
							total_items++;
							comparison_str = comparison_ids + ',' + hotel_code;
						}
					}

					if (total_items > min_total_items) {
						Cookies.set('hotel_comparison_ids', comparison_str, {
							expires: 7,
							path   : '/'
						});

						showComparisonWidget();
					} else {
						Cookies.remove('hotel_comparison_ids');
						$('.hotel-badge').html(1);

						hideComparisonWidget();
					}
				} else if (comparison_ids) {
					comparison_str = '';
					ids            = comparison_ids.split(',');
					total_items    = 0;

					Adzuki.Ajax
						.get('/HotelBooking/removeFromComparison/' + hotel_code)
						.then(
							function success(response) {
								for (i=0;i<=ids.length;i++) {
									if (parseInt(ids[i]) === parseInt(hotel_code)) {
										ids.splice(i, 1);
									} else {
										total_items++;
									}
								}

								comparison_str = ids.join(",");

								if (total_items > min_total_items) {
									Cookies.set('hotel_comparison_ids', comparison_str, {
										expires: 7,
										path   : '/'
									});

									showComparisonWidget();
								} else {
									Cookies.remove('hotel_comparison_ids');
									$('.hotel-badge').html(1);

									hideComparisonWidget();
								}
							}
						);
				}
			});

			$comparison_container.on('click', '.hotel-comparison-remove', function comparisonRemoveOne(e) {
				var comparison_ids  = Cookies.get('hotel_comparison_ids') || '',
				    comparison_str  = '',
				    ids             = '',
				    code            = $(this).data("id"),
				    i               = 0,
				    min_total_items = 0,
				    decrementor     = 1;

				e.preventDefault();


				ids = comparison_ids.split(',');

				for (i=0;i<=ids.length;i++) {
					if (parseInt(ids[i]) !== parseInt(code)) {
						if (comparison_str === '' && ids[i] !== code && !isNaN(ids[i])) {
							comparison_str = ids[i];
						} else if (ids[i]) {
							comparison_str += ',' + ids[i];
						}
					}
				}

				$('.hotel-comparison').each(function uncheckOne() {
					if ($(this).data("hotel-code") === code) {
						$(this).prop('checked', false);
					}
				});

				total_items = parseInt(ids.length) - decrementor;

				// remove specific code from the session
				Adzuki.Ajax
					.get('/HotelBooking/removeFromComparison/' + code)
					.then(
						function success(response) {
							if (total_items > min_total_items) {
								Cookies.set('hotel_comparison_ids', comparison_str, {
									expires: 7,
									path   : '/'
								});

								showComparisonWidget();
							} else {
								Cookies.remove('hotel_comparison_ids');
								hideComparisonWidget();
							}
						}
					);
			});

			$comparison_container.on('click', '.hotel-comparison-remove-all', function comparisonRemoveAll() {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to remove all?',
					confirm: function confirm() {
						Adzuki.Ajax.get('/HotelBooking/removeFromComparison/');
						Cookies.remove('hotel_comparison_ids');
						// showComparisonWidget();

						$('.hotel-comparison').each(function uncheckAll() {
							$(this).prop('checked', false);
						});

						hideComparisonWidget();
					}
				});
			});

			$comparison_container.on('click', '.hotel-comparison-view', function comparisonRemoveAll() {
				var comparison_ids  = Cookies.get('hotel_comparison_ids') || '';

				document.location = Adzuki.base_uri + '/HotelBooking/compare/' + comparison_ids;
			});

			$comparison_container.on('click', '.hotel-comparison-toggle', function toggleState() {
				Cookies.set('hotel-comparison-collapsed', !$(this).hasClass('collapsed'));
			});

			if (Cookies.get('hotel_comparison_ids')) {
				if (Cookies.get('hotel_comparison_ids').length > 0) {
					showComparisonWidget();
				}
			}
			// end comparison
		});
	});

	function showComparisonWidget() {
		var comparison_ids = Cookies.get('hotel_comparison_ids'),
		    collapsed      = Cookies.get('hotel-comparison-collapsed') || false;

		if (typeof comparison_ids === 'undefined') {
			hideComparisonWidget();
		} else {
			$('.hotel-comparison-widget-box').show();

			Adzuki.Ajax
				.get('/HotelBooking/comparisonWidget/' + comparison_ids)
				.then(
					function success(response) {
						$('.hotel-comparison-widget').html(response);

						if (collapsed === 'true') {
							$('.hotel-comparison-toggle').click();
						}
					}
				);
		}
	}

	function hideComparisonWidget() {
		$('.hotel-comparison-widget').html('');
		$('.hotel-comparison-widget-box').hide();
	}

}(jQuery, window.Adzuki || {}));
